<template>
    <div>
        <!-- Modal -->
        <div class="modal fade" id="shareCotacaoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="aquisicao">
                    <div class="modal-header">
                        <h5 class="modal-title">Enviar Solicitação de Cotação</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="card" v-for="(forn, ifx) in aquisicao.fornecedores" :key="ifx">
                            <div class="card-header">
                                {{ forn.fornecedor.search }}
                            </div>
                            <div class="card-body">
                                <az-input
                                    type="fone"
                                    v-model="forn.fornecedor.st_telefone">
                                    <template v-slot:button-pre>
                                        <div class="input-group-prepend">
                                            <span class="input-group-text" id="basic-addon1">
                                                <i class="fa fa-whatsapp fa-fw" aria-hidden="true"></i>
                                            </span>
                                        </div>
                                    </template>
                                    <template v-slot:buttonposb>
                                        <div class="input-group-append">
                                            <a :href="whatsapp_link(forn)" 
                                                :target="forn.fornecedor.st_telefone ? '_blank' : ''" 
                                                :disabled="!forn.fornecedor.st_telefone"
                                                class="btn btn-success">Enviar</a>
                                        </div>
                                    </template>
                                </az-input>

                                <az-input
                                    type="email"
                                    v-model="forn.fornecedor.st_email1">
                                    <template v-slot:button-pre>
                                        <div class="input-group-prepend">
                                            <span class="input-group-text" id="basic-addon1">
                                                <i class="far fa-envelope-open fa-fw"></i>
                                            </span>
                                        </div>
                                    </template>
                                    <template v-slot:buttonposb>
                                        <div class="input-group-append">
                                            <az-submit :disabled="!forn.fornecedor.st_email1" @click="enviar_cotacao_fornecedor(forn)">Enviar</az-submit>
                                        </div>
                                    </template>
                                </az-input>
                            </div>
                        </div>
                        <div v-if="flIntegracaoSintese" class="card">
                            <div class="card-header">
                                Síntese
                            </div>
                            <div class="card-body">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">
                                            <i class="far fa-share"></i>
                                        </span>
                                    </div>
                                    <input type="text" class="form-control" readonly value="Enviar Requisicão">
                                    <div class="input-group-append">
                                        <az-submit @click="enviar_requisicao_sintese(aquisicao, 'I')">Enviar</az-submit>
                                    </div>
                                </div>

                              <div class="input-group mt-1">
                                <div class="input-group-prepend">
                                        <span class="input-group-text">
                                            <i class="far fa-download"></i>
                                        </span>
                                </div>
                                <input type="text" class="form-control" readonly value="Importar Mapa de Cotação">
                                <div class="input-group-append">
                                  <az-submit @click="importar_requisicao_sintese(aquisicao)">Importar</az-submit>
                                </div>
                              </div>

                              <div class="input-group mt-1">
                                <div class="input-group-prepend">
                                        <span class="input-group-text">
                                            <i class="far fa-download"></i>
                                        </span>
                                </div>
                                <input type="text" class="form-control" readonly value="Importar Ordem de Compra">
                                <div class="input-group-append">
                                  <az-submit @click="importar_ordem_compra_sintese(aquisicao)">Importar</az-submit>
                                </div>
                              </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';

export default {
    data() { 
        return { 
            aquisicao: null, 
            flIntegracaoSintese: false,
            flIntegracaoBionexo: false,
        };
    },

    components: { 
        AzInput,
        AzSubmit, 
    },

    methods: { 
        abrir(aqs) { 
            this.aquisicao = _.cloneDeep(aqs);
            this.checar_sintese();

            $('#shareCotacaoModal').modal('show');
        },

        enviar_cotacao_fornecedor(af) { 
            if ( !confirm('Confirma enviar a solicitação de cotação para o fornecedor por e-mail?') ) { 
                return;
            }

            this.$util.atualizar(this, { 
                service: 'aquisicao_ordem_compras',
                func: 'enviar_cotacao_fornecedor',
                redir_api: true, 
                dados: { 
                    id_aquisicao_fornecedor: af.id_aquisicao_fornecedor,
                    email: af.fornecedor.st_email1.split(';'), 
                },
                callback: res => { 
                    if ( res.length ) { 
                        this.$toast.add({
                            severity: "success",
                            summary: "Atenção",
                            detail: "Solicitação de cotação enviada para: " + res.join(','),
                            life: 3000
                        });
                    }
                },
            });
        },

        whatsapp_link(af) {
            let nl = "\n"; // "%0D%0A";
            let msg = "";
            let celular = "";

            msg = msg + af.fornecedor.search;
            celular = af.fornecedor.st_telefone;
            
            if (!celular) {
                return "javascript:alert('Celular não disponível')";
            }

            celular = "55" + celular;

            msg = msg + nl;

            msg = msg + "Segue Solicitação de Cotação #" + af.id_aquisicao + nl;
            msg = msg + af.link; 

            if ( af.link_formulario_cotacao ) { 
                msg = msg + nl + nl + "Formulário Cotação: " + nl + af.link_formulario_cotacao;
            }
            
            return "https://wa.me/" + celular + "?text=" + encodeURIComponent(msg);
        },

        checar_sintese() {
            let query = {
                q: [
                    {
                        name: "configuracoes.check",
                        id: "sintese",
                        parms: {
                            st_slug: "integracao-sintese",
                            st_valor: "1",
                        }
                    },
                    {
                        name: "configuracoes.check",
                        id: "bionexo",
                        parms: {
                            st_slug: "integracao-bionexo",
                            st_valor: "1",
                        }
                    }
                ]
            }

            this.axios.post('/aql', query)
                .then(res => {
                
                    if(_.get(res, 'data.sintese.status') == 200 && _.get(res, 'data.sintese.data')) {
                        this.flIntegracaoSintese = res.data.sintese.data
                    }
                    
                    if(_.get(res, 'data.bionexo.status') == 200 && _.get(res, 'data.bionexo.data')) {
                        this.flIntegracaoBionexo = res.data.bionexo.data
                    }

                });
        },

        enviar_requisicao_sintese(aqs, tipoMovimento) {

            this.$util.atualizar(this, { 
                service: 'aquisicao_ordem_compras',
                func: 'enviar_requisicao_sintese',
                redir_api: true, 
                dados: { 
                    id_aquisicao: aqs.id_aquisicao,
                    tipo_movimento: tipoMovimento,
                },
                callback: res => {
                    this.$toast.add({
                        severity: res.status != 200 ? "error" : "success",
                        summary: res.status != 200 ? "Erro" : "Sucesso",
                        detail: res.msg ? res.msg : "Erro ao enviar requisição para Síntese.",
                        life: 3000
                    });
                }
            });
        },

        enviar_status_ordem_compra_sintese(aqs, status) { 
            console.log(aqs)
            let soc = aqs.ocs[0];
                this.$util.atualizar(this, { 
                    service: 'aquisicao_ordem_compras',
                    func: 'enviar_status_ordem_compra_sintese',
                    redir_api: true, 
                    dados: { 
                        id_aquisicao_ordem_compra: soc.id_aquisicao,
                        tipo_movimento: status,
                    },
                    callback: res => {
                        this.$toast.add({
                            severity: res.status != 200 ? "error" : "success",
                            summary: res.status != 200 ? "Erro" : "Sucesso",
                            detail: res.msg ? res.msg : "Erro ao enviar requisição para Síntese.",
                            life: 3000
                        });
                    }
                });
        },

      importar_requisicao_sintese(aqs) {
        var downloadAnchorNode = document.createElement("input");
        downloadAnchorNode.setAttribute("type", "file");
        downloadAnchorNode.setAttribute("class", "d-none");
        downloadAnchorNode.onchange = () => {
          var file = downloadAnchorNode.files[0];
          if (file) {
            var reader = new FileReader();

            //checar se arquivo é csv;
            var fileName = file.name;
            var fileExtension = fileName.split('.').pop().toLowerCase();

            if (fileExtension != 'xml') {
              this.$toast.add({
                severity: "error",
                summary: "Atenção",
                detail: "Arquivo inválido. Selecione um arquivo .xml",
                life: 3000,
              });
              return;
            }

            reader.readAsText(file, "ISO-8859-1");

            reader.onload = (evt) => {
              this.$store.commit('loading', true);
              this.$util
                  .loadItem(this, {
                    service: "aquisicao_ordem_compras",
                    func: "importar_requisicao_sintese",
                    parms: {
                      id_aquisicao: aqs.id_aquisicao,
                      json: evt.target.result,
                    },
                  })
                  .then((res) => {
                    this.$toast.add({
                      severity: res.status != 200 ? "error" : "success",
                      summary: res.status != 200 ? "Erro" : "Sucesso",
                      detail: res.msg ? res.msg : "Erro ao enviar requisição para Síntese.",
                      life: 3000,
                    });
                  })
                  .finally(() => {
                    this.$store.commit('loading', false);
                  });
            };

            reader.onerror = function () {
              this.$toast.add({
                severity: "error",
                summary: "Atenção",
                detail: "Falha lendo arquivo.",
                life: 3000,
              });
            };
          }
        };
        document.body.appendChild(downloadAnchorNode);
        downloadAnchorNode.click();
      },

      importar_ordem_compra_sintese(aqs) {
        var downloadAnchorNode = document.createElement("input");
        downloadAnchorNode.setAttribute("type", "file");
        downloadAnchorNode.setAttribute("class", "d-none");
        downloadAnchorNode.onchange = () => {
          var file = downloadAnchorNode.files[0];
          if (file) {
            var reader = new FileReader();

            //checar se arquivo é csv;
            var fileName = file.name;
            var fileExtension = fileName.split('.').pop().toLowerCase();

            if (fileExtension != 'xml') {
              this.$toast.add({
                severity: "error",
                summary: "Atenção",
                detail: "Arquivo inválido. Selecione um arquivo .xml",
                life: 3000,
              });
              return;
            }

            reader.readAsText(file, "ISO-8859-1");

            reader.onload = (evt) => {
              this.$store.commit('loading', true);
              this.$util
                  .loadItem(this, {
                    service: "aquisicao_ordem_compras",
                    func: "importar_ordem_compra_sintese",
                    parms: {
                      id_aquisicao: aqs.id_aquisicao,
                      json: evt.target.result,
                    },
                  })
                  .then((res) => {
                    this.$toast.add({
                      severity: res.status != 200 ? "error" : "success",
                      summary: res.status != 200 ? "Erro" : "Sucesso",
                      detail: res.msg ? res.msg : "Erro ao enviar requisição para Síntese.",
                      life: 3000,
                    });
                  })
                  .finally(() => {
                    this.$store.commit('loading', false);
                  });
            };

            reader.onerror = function () {
              this.$toast.add({
                severity: "error",
                summary: "Atenção",
                detail: "Falha lendo arquivo.",
                life: 3000,
              });
            };
          }
        };
        document.body.appendChild(downloadAnchorNode);
        downloadAnchorNode.click();
      }

    }
}
</script>